/* Import Modules */
import $ from "jquery";
import axios, { AxiosRequestConfig } from "axios";
import toastr from "toastr";

/* Import Variables */
import { isShow, carModelsForPulldownByVue } from "../../variables";

/* Define Function */
const getAxiosOptions = () => {
  const axiosOptions: AxiosRequestConfig = {
    url: "/api/car_model",
    method: "GET",
    params: {},
  };

  return axiosOptions;
};

export const getCarModel = async () => {
  // Get Axios Option
  const axiosOptions = await getAxiosOptions();
  await axios(axiosOptions)
    .then((result) => {
      // Set CarModel
      let carModelsArray: Array<any> = [];
      $.each(result.data.data, function (index: any, value: any) {
        carModelsArray.push({
          text: value.name,
          value: value.id,
        });
      });
      carModelsForPulldownByVue.carModels = carModelsArray;
    })
    .catch((error) => {
      console.log(error);
      toastr.error("車種情報取得に失敗しました");
    });
};
